import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ViewContainerRef, EmbeddedViewRef, TemplateRef } from '@angular/core';
import * as Highcharts from 'highcharts';
declare var require: any;
if (typeof Highcharts === 'object') {
  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

import { DashboardService } from '../../../../shared/providers/dashboard.service';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';

@Component({
    selector: 'app-p-dashboard-charts',
    templateUrl: './p-dashboard-charts.component.html',
    styleUrls: ['./p-dashboard-charts.component.css']
})
export class PDashboardChartsComponent implements OnInit {

    constructor(private Dashboard: DashboardService, private PropertyListing: PropertyListingService) { }
    @Input() propertyId = 0;
    @Input() IsPortfolio: boolean = false;
    @Input() isFromPortfolio: boolean = false;
    public LineMarketingReport: any = {}
    public BarProspectsStatus: any = {}
    //defaultText: IMultiSelectTexts = {
    //    allSelected: 'All selected',
    //};
    defaultSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      enableFilterSelectAll: false,
    };
    marketingList = [];
    period = 3;
    marketingReportSeries = [];
    marketingReportXaxis = [];
    marketingIDs = [];
    marketingChartData = [];
    propertyIds = [];
    prospectPeriod = 3;
    selectedItem = 'Views';
    private chartLabelOptions = {
        style: {
          fontSize: '12px'
        }
      };
    ngOnInit() {

        this.marketingList = [{
            name: 'Views',
            id: 'Views'
        }, {
            name: 'OM Downloads',
            id: 'OMDownload'
        }, {
            name: 'Calls',
            id: 'Calls'
        }, {
            name: 'Emails',
            id: 'Emails'
        }, {
            name: 'NDAs',
            id: 'NDA'
        }];
        this.marketingIDs = this.marketingList.map(x => x.id);
        if (!this.IsPortfolio) {
            this.selectedProperties.push(this.propertyId);
            this.bindMarketingReport();
        }

        this.bindProspectsStatus();
        this.bindPortfolioProperties();
    }
    portfolioProperties = [];
    selectedProperties = [];
    private bindPortfolioProperties() {
        if (this.IsPortfolio) {
            this.PropertyListing.GetPortfolioProperties(this.propertyId).subscribe(response => {
                console.log(response);
                this.portfolioProperties = response.map(o => { return { id: o.Id, name: o.PropertyName }; });
                this.propertyIds.push(response.find(x => x.IsPortfolio).Id);
                this.selectedProperties = this.portfolioProperties.map(o => o.id);
                this.bindMarketingReport();
            });
        }
        else {
            this.selectedProperties.push(this.propertyId);
        }
    }

    redrawMarketingReport(event) {
        this.bindMarketingChart();
    }
    periodChange() {
        this.bindMarketingReport();
    }
    bindMarketingChart() {
        
        let that = this;

      if (!this.IsPortfolio) {
            this.marketingChartData = Object.assign([], this.marketingReportSeries.filter(x => this.marketingIDs.includes(this.marketingList.find(y => y.name == x.name)["id"])));
            this.LineMarketingReport = {
                title: {
                    text: ''
                },
                yAxis: {
                    min: 0.1,
                    title: {
                        text: ''
                    },
                    labels:
                    {
                        enabled: true,
                        formatter: function () {
                            if (this.value == 0.1) {
                                return Highcharts.numberFormat(this.value - 0.1, 0);
                            }
                            else {
                                return Highcharts.numberFormat(this.value, 0);
                            }
                        },
                        ...this.chartLabelOptions
                    },
                    type: 'logarithmic',
                    minorTickInterval: 1,
                },
                xAxis: {
                    categories: this.marketingReportXaxis,
                    labels: {
                        formatter: function () {
                            let name = [] = this.value.split('|');
                            return '<b>' + name[0] + '</b>';
                        },
                        ...this.chartLabelOptions
                    }
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: true,
                            style: {
                                fontSize: '12px'
                              },
                        },
                        events: {
                            legendItemClick: function () {
                                
                                if (!this.visible) {
                                  that.marketingIDs.push(that.marketingList.find(x => x.name == this.name)["id"])
                                }
                                else {
                                    that.marketingIDs.splice(that.marketingIDs.findIndex(x => x == this.name), 1)
                                }
                            }
                    },
                        
                    }
                },
                series: this.marketingIDs.length == 5 ? this.marketingReportSeries : this.marketingChartData,
                tooltip: {
                    style: {
                        fontSize: '12px'
                      },
                    formatter: function () {
                        var point = this;
                        let name = point.x.replace('|', '(');
                        name = name + ")";
                        var y = point.y == 0.1 ? 0.00 : point.y;
                        return '<span style="color:' + point.color + ';padding:0">' + point.series.userOptions.name + '</span><br><table><tr><td>' + name + '</td><br></tr><tr><td><b>' + y + '</b></td></tr></table>';
                    }
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom',
                                itemStyle: {
                                    fontSize: '12px'
                                  }
                            }
                        }
                    }]
                }
            };
        }
        else {
          let chartIndex = 0;
            let data = this.marketData.filter(x => this.propertyIds.includes(x.PropertyId));
            let xAxis = data.map(o => o.Dates);
        let chartData = [];
        let colorIndex = 0;
            this.propertyIds.forEach(item => {
                let pdata = [];
                data.filter(x => x.PropertyId == item).map(x => x[this.selectedItem]).forEach(function (value) {
                    if (value == 0) {
                        pdata.push(0.1);
                    }
                    else {
                        pdata.push(value);
                    }
                });

              let propertyname = this.portfolioProperties.find(x => x.id == item)["name"];
              let Color = propertyname != null ? propertyname == 'Views' ? this.getChartColor(0) : propertyname == 'Calls' ? this.getChartColor(2) : propertyname == 'Emails' ? this.getChartColor(3) :
                propertyname == 'NDAs' ? this.getChartColor(4) : propertyname == 'OM Downloads' ? this.getChartColor(1) : '' : '';
              if (Color == '') {
                Color = this.getChartColor(colorIndex);
                colorIndex++;
              }
                const d =
                {
                    name: propertyname,
                  data: pdata,
                  color: Color
                 
              }
              
              chartData.push(d);
              chartIndex++;
            });
            this.LineMarketingReport = {
                title: {
                    text: ''
                },
                yAxis: {
                    min: 0.1,
                    title: {
                        text: ''
                    },
                    labels:
                    {
                        ...this.chartLabelOptions,
                        enabled: true,
                        formatter: function () {
                            if (this.value == 0.1) {
                                return Highcharts.numberFormat(this.value - 0.1, 0);
                            }
                            else {
                                return Highcharts.numberFormat(this.value, 0);
                            }
                        }
                    },
                    type: 'logarithmic',
                    minorTickInterval: 1,
                },
                xAxis: {
                    categories: xAxis,
                    labels: {
                        ...this.chartLabelOptions,
                        formatter: function () {
                            let name = [] = this.value.split('|');
                            return '<b>' + name[0] + '</b>';
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: true,
                            style: {
                                fontSize: '12px'
                              },
                        },
                        events: {
                            legendItemClick: function () {
                                return false;
                            }
                        }
                    }
                },
                series: chartData,
                tooltip: {
                    style: {
                        fontSize: '12px'
                      },
                    formatter: function () {
                        var point = this;
                        let d: string = point.x.toString();
                        let name = d.split('|')[1];
                        //name = name + ")";
                        var y = point.y == 0.1 ? 0.00 : point.y;
                        return '<span style="color:' + point.color + ';padding:0">' + point.series.userOptions.name + '</span><br><table><tr><td>' + name + '</td><br></tr><tr><td><b>' + y + '</b></td></tr></table>';
                    }
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom',
                                itemStyle: {
                                    fontSize: '12px'
                                  }
                            }
                        }
                    }]
                }
            };
        }
        Highcharts.chart('LineMarketingReport', this.LineMarketingReport);
    }
    prospectPeriodChange() {
        this.bindProspectsStatus();
    }
    private bindMarketingReport() {
        let that = this;
        if (!this.IsPortfolio) {
            this.Dashboard.GetMarketingReport(this.selectedProperties, that.period).subscribe(response => {
                that.marketingReportXaxis = [];
                response.map(o => o["Dates"]).forEach(function (value) {
                    if (value == 0) {
                        that.marketingReportXaxis.push(0.1);
                    }
                    else {
                        that.marketingReportXaxis.push(value);
                    }
                });

                let Views = [];
                response.map(o => o["Views"]).forEach(function (value) {
                    if (value == 0) {
                        Views.push(0.1);
                    }
                    else {
                        Views.push(value);
                    }
                });;
                let ViOMDownload = [];
                response.map(o => o["OMDownload"]).forEach(function (value) {
                    if (value == 0) {
                        ViOMDownload.push(0.1);
                    }
                    else {
                        ViOMDownload.push(value);
                    }
                });
                let Calls = [];
                response.map(o => o["Calls"]).forEach(function (value) {
                    if (value == 0) {
                        Calls.push(0.1);
                    }
                    else {
                        Calls.push(value);
                    }
                });;
                let Emails = [];
                response.map(o => o["Emails"]).forEach(function (value) {
                    if (value == 0) {
                        Emails.push(0.1);
                    }
                    else {
                        Emails.push(value);
                    }
                });;
                let NDA = [];
                response.map(o => o["NDA"]).forEach(function (value) {
                    
                    if (value == 0) {
                        NDA.push(0.1);
                    }
                    else {
                        NDA.push(value);
                    }
                });

                that.marketingReportSeries = [{
                    name: 'Views',
                  data: Views,
                  color: this.getChartColor(0)
                }, {
                    name: 'OM Downloads',
                    data: ViOMDownload,
                    color: this.getChartColor(1)
                }, {
                    name: 'Calls',
                    data: Calls,
                    color: this.getChartColor(2)
                }, {
                    name: 'Emails',
                    data: Emails,
                    color: this.getChartColor(3)
                }, {
                    name: 'NDAs',
                    data: NDA,
                    color: this.getChartColor(4)
                }]
                let i = 0
                //that.marketingReportSeries.forEach(item => {
                //    that.marketingList.push({ id: i, name: item.name })
                //    i++;
                //});            

                that.bindMarketingChart()
            });
        }
        else {
            this.Dashboard.GetMarketingReport(this.selectedProperties, this.period).subscribe(response => {
                this.marketData = response;
                that.bindMarketingChart();
            });
        }
    }
    marketData = [];
    private bindProspectsStatus() {
        this.Dashboard.GetProspectsStatusForDashboard(this.propertyId, this.prospectPeriod).subscribe(response => {
            let Xaxis = [] = response.map(o => o["Name"]);
            let Value = [] = response.map(o => o["Value"]);
            this.BarProspectsStatus = {
                chart: {
                    type: 'bar',
                    title: ''
                },
                title: {
                    text: ''
                },
                xAxis: {
                    labels: this.chartLabelOptions,
                    categories: Xaxis,
                    title: {
                        text: ''
                    }
                },
                yAxis: {
                    labels: this.chartLabelOptions,
                    title: {
                        text: ''
                    },
                    allowDecimals: false
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            style: {
                                fontSize: '12px'
                              }
                        }
                    }
                },
                legend: {
                    enabled: false,
                    itemStyle: {
                        fontSize: '12px'
                      }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    style: {
                        fontSize: '12px',
                       },
                    formatter: function () {
                        var point = this;
                        let name = point.x.replace('|', '(');
                        name = name + ")";
                        var y = point.y == 0.1 ? 0.00 : point.y;
                        return '<span style="color:' + point.color + ';padding:0">' + point.x + ':</span>'+y+'<br><table><tr><td></tr></table>';
                    }
                },
                series: [{
                    name: 'Status',
                  data: Value,
                  color: '#198FDE',
                  fontSize: '12px'
                }]
            };
            Highcharts.chart('BarProspectsStatus', this.BarProspectsStatus);
        });
  }

  getChartColor(index) {
    const colors = ['#198FDE', '#003A5D', '#59595B', '#02C29F','#A7A8A9',' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
    return colors[index];
  }
}
